import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { media } from "@/config/site";
import { waMessages } from "@/lib/whatsapp";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import MediaImage from "@/components/feature/MediaImage";

const navItems = [
  { label: "Hizmetler", to: "/#hizmetler" },
  { label: "Gelin Hazırlığı", to: "/#gelin" },
  { label: "Çalışmalarımız", to: "/#calismalarimiz" },
  { label: "Hikâyemiz", to: "/#hikayemiz" },
  { label: "İletişim", to: "/#iletisim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-300/50 bg-background-100/95 backdrop-blur"
          : "bg-background-100"
      }`}
    >
      <nav
        className="flex items-center justify-between px-4 py-4 md:px-6"
        aria-label="Ana menü"
      >
        <Link to="/" className="flex items-center gap-3" aria-label="gülaYonar ana sayfa">
          <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-background-200">
            <MediaImage
              src={media.logo}
              alt="gülaYonar logosu"
              objectPosition="object-center"
              eager
              className="h-full w-full"
            />
          </span>
          <span className="font-heading text-2xl tracking-wide text-primary-800 md:text-[1.7rem]">
            gülaYonar
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          <ul className="flex items-center gap-7">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-accent-600"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <WhatsAppLink
            message={waMessages.general}
            label="WhatsApp'tan Ulaşın"
            variant="primary"
            size="sm"
            sourceSection="navbar"
            className="whitespace-nowrap"
          />
        </div>

        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-11 w-11 items-center justify-center rounded-md text-primary-800 md:hidden"
          aria-label="Menüyü aç"
          aria-expanded={menuOpen}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-300/60 bg-background-100 px-4 pb-5 pt-2 md:hidden">
          <ul className="flex flex-col">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="block py-3 font-heading text-xl text-primary-800 transition-colors hover:text-accent-600"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <WhatsAppLink
            message={waMessages.general}
            label="WhatsApp'tan Ulaşın"
            variant="primary"
            size="md"
            sourceSection="navbar_mobile"
            className="mt-3 w-full"
          />
        </div>
      )}
    </header>
  );
}